// extracted by mini-css-extract-plugin
export default {"numbersSelect":"number-select_numbersSelect__MPPoc","number":"number-select_number__LErv0","num":"number-select_num__G2iBh"};